var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import useCurrentUser from './useCurrentUser';
/**
 * Generic hook to manage and reset filters by current company.
 * @param defaultFilters - The initial/default filters.
 * @returns A tuple with the current filters and a function to update them.
 * @callback onReset callback to excecute additional logic on filters reset.
 */
var useFilters = function (defaultFilters, onReset) {
    var _a = __read(useState(defaultFilters), 2), filters = _a[0], setFilters = _a[1];
    var companyId = useCurrentUser().companyId;
    useEffect(function () {
        if (companyId) {
            setFilters(__assign(__assign({}, defaultFilters), { companyId: companyId }));
            onReset();
        }
    }, [companyId]);
    return [filters, setFilters];
};
export default useFilters;
